import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga";
import "./index.css";
import "@tremor/react/dist/esm/tremor.css";
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react'; // Provider imports 'rollbar'
import config from "config";

ReactGA.initialize("G-59HX6GHZ3X");
ReactGA.pageview(window.location.pathname + window.location.search);


const rollbarConfig = {
  accessToken: config.rollbar.accessToken,
  environment: config.rollbar.environment,
};

const container = document.getElementById("root")!;
const root = createRoot(container);


root.render(
  <RollbarProvider config={rollbarConfig}>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </RollbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
